// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.disabled[data-v-2efecdc9]{pointer-events:none!important;cursor:default!important}.btn-link.text-dark[data-v-2efecdc9]{color:#000!important}.btn-link.text-muted[data-v-2efecdc9]{color:#adb5bd!important}", ""]);
// Exports
module.exports = exports;
